<template>
  <v-alert
    type="info"
    variant="tonal"
    icon="mdi-information"
    class="mt-4"
  >
    <strong>You don't own this deposit, so you can't upload files to it.</strong>
    Ensure that you are logged in as the correct user, via the depositor one-time code login, to upload to this deposit.
  </v-alert>
</template>
